export const customers = {
  title: 'العملاء',
  description: 'إدارة عملائك',
  form: {
    createTitle: 'عميل جديد',
    editTitle: 'تعديل العميل',
    fields: {
      name: 'الاسم',
      email: 'البريد الإلكتروني',
      phone: 'الهاتف',
      address: 'العنوان',
      notes: 'ملاحظات',
      isActive: 'نشط',
      solde: 'الرصيد'
    },
    placeholders: {
      name: 'أدخل اسم العميل',
      email: 'أدخل البريد الإلكتروني للعميل',
      phone: 'أدخل رقم الهاتف',
      address: 'أدخل العنوان',
      notes: 'أضف ملاحظات عن العميل'
    },
    validations: {
      required: 'هذا الحقل مطلوب',
      email: 'الرجاء إدخال بريد إلكتروني صالح',
      phone: 'الرجاء إدخال رقم هاتف صالح',
      minLength: 'يجب أن يحتوي هذا الحقل على {min} أحرف على الأقل',
      maxLength: 'يجب ألا يتجاوز هذا الحقل {max} حرف',
      positiveNumber: 'يجب أن يكون المبلغ موجبًا'
    },
    create: 'إنشاء',
    update: 'تحديث',
    cancel: 'إلغاء',
    submitting: 'جاري الحفظ...'
  },
  columns: {
    name: 'الاسم',
    email: 'البريد الإلكتروني',
    phone: 'الهاتف',
    address: 'العنوان',
    notes: 'ملاحظات',
    isActive: 'الحالة',
    solde: 'الرصيد',
    createdAt: 'تاريخ الإنشاء',
    updatedAt: 'تاريخ التحديث',
    lastSync: 'آخر مزامنة',
    basicInfo: 'المعلومات الأساسية',
    financialInfo: 'التفاصيل المالية',
    systemInfo: 'معلومات النظام'
  },
  filters: {
    search: {
      label: 'بحث',
      placeholder: 'ابحث عن عميل...'
    },
    status: {
      label: 'الحالة',
      active: 'نشط',
      inactive: 'غير نشط'
    }
  },
  actions: {
    newCustomer: 'عميل جديد',
    edit: 'تعديل',
    delete: 'حذف',
    view: 'عرض'
  },
  confirmations: {
    delete: 'هل أنت متأكد من حذف هذا العميل؟',
    deleteSuccess: 'تم حذف العميل بنجاح',
    createSuccess: 'تم إنشاء العميل بنجاح',
    updateSuccess: 'تم تحديث العميل بنجاح'
  },
  errors: {
    load: 'خطأ في تحميل العملاء',
    create: 'خطأ في إنشاء العميل',
    update: 'خطأ في تحديث العميل',
    delete: 'خطأ في حذف العميل'
  },
  pagination: {
    totalItems: 'إجمالي العناصر',
    previous: 'السابق',
    next: 'التالي',
    page: 'الصفحة',
    showing: 'عرض',
    to: 'إلى',
    of: 'من',
    items: 'عناصر'
  },
  currency: 'درهم'
}; 